"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSessionService = void 0;
const utils_1 = require("@hc-frontend/utils");
const __1 = require("..");
/**
 * Fetch the location using the current ip of the browser
 *
 * @public
 *
 * @param {IPayloadSessionService} payload - The payload to send to the session manager
 *
 * @returns {IFetchSessionServiceResponse | null} - The response from the session manager
 *
 * @example
 * ```ts
 * const location = await fetchLocationByIpService();
 * ```
 */
async function fetchSessionService(payload) {
    const url = `${(0, __1.getSessionManagerURI)()}/session`;
    const { parsedBody } = await (0, utils_1.fetchJSON)(url, {
        body: payload,
    });
    return (parsedBody === null || parsedBody === void 0 ? void 0 : parsedBody.UserId) ? parsedBody : null;
}
exports.fetchSessionService = fetchSessionService;
//# sourceMappingURL=fetch-session-service.js.map